import React from "react"
import IconLinkContainerItem from "./icon-link-container-item"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"

export default function IconLinkContainerComponent({ iconLinkCards, topPadding, bottomPadding, backgroundColor }) {
  const htmlIconCards =
    iconLinkCards && iconLinkCards.length > 0
      ? iconLinkCards.map((card) => {
          return (
            <IconLinkContainerItem
              key={card.text}
              altText={card.altText}
              image={card.image}
              link={card.link}
              linkTarget={SelectionFactoryHelper.getFromSelectionFactory(card.linkTarget)}
              linkTitle={card.linkTitle}
              text={card.text}
              svgIcon={SelectionFactoryHelper.getFromSelectionFactory(card.svgIcon)}
            />
          )
        })
      : undefined

  const selectedTopPadding = SelectionFactoryHelper.getFromSelectionFactory(topPadding)
  const selectedBottomPadding = SelectionFactoryHelper.getFromSelectionFactory(bottomPadding)
  const selectedBackgroundColor = SelectionFactoryHelper.getFromSelectionFactory(backgroundColor)

  return (
    <section className={`icon-link-cards-section ${selectedTopPadding ?? ""} ${selectedBottomPadding ?? ""} ${selectedBackgroundColor}`}>
      <div className="w--wider">
        <div data-epi-property="IconLinkCards" className="icon-link-container">
          {htmlIconCards}
        </div>
      </div>
    </section>
  )
}
